<template>
  <div class="wh-screen">
    <warehouse-entry-grocery-dialog
      v-if="editedItem"
      v-model="entryDialog"
      :warehouse="editedItem.warehouse || {}"
      :edited-item="editedItem"
      @success="onEntrySuccess"
    />
    <warehouse-doc-screen
      v-bind="docProps"
      :mobile="device.isMobile"
      @update:aggregate="aggregateMode = $event"
      @hint="setFiltersToLastEntry"
      @action="onDocAction"
      @open-row="openRowDoc"
      @toast="$emit('toast', $event)"
    >
      <template #row-actions="{ row }">
        <warehouse-row-button icon="mdi-eye" :label="$t('overview')" tone="pri" action="view" @click="openRowDoc(row)" />
      </template>
      <template #detail-actions="{ row }">
        <warehouse-row-button icon="mdi-eye" :label="$t('overview')" tone="pri" action="view" @click="openRowDoc(row)" />
      </template>
    </warehouse-doc-screen>
  </div>
</template>

<script>
import WarehouseTabEntry from "@/components/warehouse/tabs/WarehouseTabEntry.vue";
import WarehouseDocScreen from "../../docs/WarehouseDocScreen.vue";
import WarehouseRowButton from "../../docs/WarehouseRowButton.vue";
import hasDocumentListScreen from "../../docs/hasDocumentListScreen";

/**
 * Dopuna magacina (primke): lista dokumenata ili zbirni prikaz po artiklu, "Dodaj u magacin" u traci alata.
 * Nasleđuje učitavanje, filtriranje, štampu, Excel i dijalog iz starog taba.
 */
export default {
  name: "WarehouseScreenEntry",
  extends: WarehouseTabEntry,
  mixins: [hasDocumentListScreen],
  components: { WarehouseDocScreen, WarehouseRowButton },
  computed: {
    docConfig() {
      return {
        icon: "mdi-package-variant-plus",
        hintKey: "warehouse.last_entry_date",
        emptyTitleKey: "warehouse.no_entries",
        emptyTextKey: "warehouse.no_entries_yet",
        dateLabel: this.$t("date"),
        open: "openDocument",
        remove: null,
        run: "openAddDialog",
        action: { key: "add", label: this.$t("add_warehouse"), icon: "mdi-plus", tone: "pri" },
      };
    },
    /** Stari tab nije primenjivao pretragu na listu dokumenata (samo na zbirni prikaz): ovde važi i za štampu i Excel. */
    displayedDocuments() {
      return this.customSearch(
        WarehouseTabEntry.computed.displayedDocuments.call(this),
        this.headers,
        this.filters.search
      );
    },
    docExtraColumns() {
      return [
        { key: "supplier", label: this.$t("supplier"), mobile: "meta" },
        { key: "number", label: this.$t("warehouse.document_number"), main: true, mobile: "title" },
        { key: "document_date", label: this.$t("date"), mobile: "meta" },
        { key: "total_items", label: this.$t("warehouse.items_count"), align: "center", mobile: "meta" },
      ];
    },
    docKpiExtra() {
      if (this.aggregateMode) {
        return [];
      }
      return [
        {
          key: "items",
          label: this.$t("warehouse.items_count"),
          value: this.docRows.reduce((sum, row) => sum + row.total_items, 0),
        },
      ];
    },
  },
};
</script>
